import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: 'pc-floor-left-and-right',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '切换楼层组',
          icon: 'el-icon-menu',
          content: {
            leftAdImg: '',
            leftAdLink: {},
            leftBrandList: [],
            leftTabList: [{
              label: '胶带标签',
              goods_select: []
            }],
            rightAdImg: '',
            rightAdLink: {},
            rightBrandList: [],
            rightTabList: []
          },
          config: [{
            label: '左侧广告图',
            name: 'leftAdImg',
            type: 'image',
            value: ''
          }, {
            label: '左侧广告图链接',
            name: 'leftAdLink',
            type: 'link',
            value: ''
          }, {
            label: '左侧品牌组',
            name: 'leftBrandList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }, {
            label: '左侧分组数据',
            name: 'leftTabList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              goods_select: {
                label: '商品数据',
                value: []
              }
            }
          }, {
            label: '右侧广告图',
            name: 'rightAdImg',
            type: 'image',
            value: ''
          }, {
            label: '右侧广告图链接',
            name: 'rightAdLink',
            type: 'link',
            value: ''
          }, {
            label: '右侧品牌组',
            name: 'rightBrandList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }, {
            label: '右侧分组数据',
            name: 'rightTabList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              goods_select: {
                label: '商品数据',
                value: []
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      leftTab: 0,
      rightTab: 0,
      leftGoods: [[]],
      rightGoods: [[]]
    };
  },
  watch: {
    leftTab: {
      handler: function handler(val) {
        this.getItem(val);
      }
    },
    rightTab: {
      handler: function handler(val) {
        this.getItem(val, 'rightTabList', 'rightGoods');
      }
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var left = this.widgets.content.leftTabList;
    var right = this.widgets.content.rightTabList;
    var arr1 = [];
    var arr2 = [];
    if (left) {
      left.forEach(function (_) {
        arr1.push([]);
      });
      this.leftGoods = arr1;
      this.getItem();
    }
    if (right) {
      right.forEach(function (_) {
        arr2.push([]);
      });
      this.rightGoods = arr2;
      this.getItem(0, 'rightTabList', 'rightGoods');
    }
  },
  methods: {
    getItem: function getItem() {
      var _this = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'leftTabList';
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'leftGoods';
      if (this.widgets.content[source].length) {
        var idList = this.widgets.content[source][index].goods_select;
        if (this[target][index] && this[target][index].length) return;
        if (idList && idList.length) {
          this.apiPost('/bbb/goodsInfo/listData', {
            idList: idList,
            sortByParamId: true
          }).then(function (res) {
            var jsonArray = res.data;
            _this.$set(_this[target], index, jsonArray);
          });
        }
      }
    },
    handleLink: function handleLink(item) {
      var activeId = item.marketingGeneral.fullCutRuleList.map(function (item) {
        return item.ruleId;
      }).join(',');
      if (activeId) {
        this.addTrack('campaign_product_click', {
          userId: this.$store.state.userInfo.userId,
          goodsId: item.id,
          activeId: activeId,
          labelId: ''
        });
      }
    }
  }
};